export enum ShippingCountryEnum {
  ShippingCountryCollection="ShippingCountryCollection",
  ShippingCountry="ShippingCountry",
}
export enum ShippingCountryDataStatus {
  active='active',
  inactive='inactive',
}
